import { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import UsersPage from "../users/UsersPage";
import BranchesPage from "./branches/BranchesPage";
import ServicesPage from "./services/ServicesPage";
import AppointmentsPage from "./appointments/AppointmentsPage";
import FollowUpsPage from "./followups/FollowUpsPage";
import InquiriesPage from "./inquiries/InquiriesPage";
import WebsiteBuilderPage from "./websitebuilder/WebsiteBuilderPage";
import MyOrganizationPage from "./MyOrganizationPage";
import ClientsPage from "./clients/ClientsPage";
import QrCodePage from "./qrcode/QrCodePage";
import OrgDashboardOverview from "./OrgDashboardOverview";
import SecurityPage from "../account/SecurityPage";
import { useAuth } from "../../hooks/useAuth";

// Import your actual page components later
// import OrgOverview from "./OrgOverview";
// import OrganizationProfile from "./OrganizationProfile";
// import Team from "./Team";
// etc.

const OrganizationDashboard = () => {
  const [searchParams] = useSearchParams();
  const querySection = searchParams.get("section");
  const [activeSection, setActiveSection] = useState(
    querySection && querySection !== "messaging" ? querySection : "dashboard",
  );
  const { user } = useAuth();

  const renderContent = () => {
    switch (activeSection) {
      case "messaging":
        return <Navigate to="/messaging" replace />;

      case "qrcode":
        return <QrCodePage />;

      case "dashboard":
        return <OrgDashboardOverview />;

      case "my-organization":
        return <MyOrganizationPage />;

      case "users":
        return (
          <UsersPage
            fixedOrganizationId={user?.activeOrganization?.organizationId}
            fixedOrganizationName={user?.activeOrganization?.name}
          />
        );

      case "branches":
        return <BranchesPage />;

      case "clients":
        return <ClientsPage />;

      case "services":
        return <ServicesPage />;

      case "appointments":
        return <AppointmentsPage />;

      case "followups":
        return <FollowUpsPage />;

      case "inquiries":
        return <InquiriesPage />;

      case "website-builder":
        return <WebsiteBuilderPage />;

      case "security":
        return <SecurityPage />;

      default:
        return <div>Section not found</div>;
    }
  };

  return (
    <DashboardLayout
      activeSection={activeSection}
      onSectionChange={setActiveSection}
    >
      {renderContent()}
    </DashboardLayout>
  );
};

export default OrganizationDashboard;